import { Project } from 'core/models/project';
import { VehicleTelemetryRepositoryFactory, VehicleTelemetryRepository } from 'core/repositories/FMS/VehicleTelemetryRepository';
import { FMSWebsocketAPIFactory } from './api/FMS/wsFactory';
import { VehicleTelemetryRepositoryImpl } from './VehicleTelemetryRepository';

export class VehicleTelemetryRepositoryFactoryImpl implements VehicleTelemetryRepositoryFactory {
    constructor(private readonly apiFactory: FMSWebsocketAPIFactory) {
    }

    async create(projectId: Project.Id): Promise<VehicleTelemetryRepository> {
        const api = await this.apiFactory.create(projectId);
        return new VehicleTelemetryRepositoryImpl(api);
    }

    async destroy(repository: VehicleTelemetryRepository): Promise<void> {
        if (repository instanceof VehicleTelemetryRepositoryImpl) {
            const api = repository.api;
            repository.dispose();
            await this.apiFactory.release(api);
        }
    }
}

export { VehicleTelemetryRepositoryFactoryImpl as VehicleTelemetryRepositoryFactory };
